import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Text } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

import { useApi } from '../../../../context/ApiProvider';
import { AllergenInterface } from '../../../../shared/type/allergen.type';
import { StickyScrollableTableContainer } from '../../../DataTable/StickyScrollableTableContainer';

const Allergens = () => {
  const { apiTenantAllergenController } = useApi();
  const { id: tenantId } = useParams();
  const [allergens, setAllergens] = useState<AllergenInterface[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const columnHelper = createColumnHelper<AllergenInterface>();

  const columns = [
    columnHelper.accessor('formalNumber', {
      cell: (info) => <p className="text-grayLight-600 font-normal text-sm">{info.getValue()}</p>,
      header: 'Lp.',
      size: 60
    }),
    columnHelper.accessor('name', {
      cell: (info) => <p className="font-medium text-sm text-grayLight-900">{info.getValue()}</p>,
      header: 'Nazwa',
      size: 200
    })
  ];

  const fetchAllergens = async () => {
    setIsLoading(true);
    try {
      const response = await apiTenantAllergenController('').get(`/${tenantId}`);
      setAllergens(response.data);
    } catch (error) {
      console.warn(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (tenantId === '0') return;
    fetchAllergens();
  }, [tenantId]);

  return (
    <section className="Allergens p-spacing-xl w-full">
      <Box mb={6}>
        <Text fontSize="xl" fontWeight="semibold" color="gray.900">
          Lista alergenów
        </Text>
        <Text fontSize="sm" color="gray.600">
          Lista wszystkich zdefiniowanych alergenów w systemie.
        </Text>
      </Box>

      <StickyScrollableTableContainer
        data={allergens}
        columns={columns}
        isLoading={isLoading}
        enableSearch={true}
        searchPlaceholder="Szukaj alergenu..."
      />
    </section>
  );
};

export default Allergens;
